import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import Routes from "./routes";
import { browserHistory } from "react-router";
import rootReducer from "./reducers/";
import createSagaMiddleware from "redux-saga";
import sagas from "./sagas";
import persistState from "redux-localstorage";
import axios from "axios";
import { reactReduxFirebase } from "react-redux-firebase";

const firebaseConfig = {
  apiKey: "AIzaSyC4GB_6vYcS042CR25QSxrHxUTie15Cp7Q",
  authDomain: "ilogs-ca734.firebaseapp.com",
  databaseURL: "https://ilogs-ca734.firebaseio.com",
  projectId: "ilogs-ca734",
  storageBucket: "ilogs-ca734.appspot.com",
  messagingSenderId: "184506905871"
};

const reactReduxFirebaseConfig = {
  userProfile: "users", // firebase root where user profiles are stored

  enableLogging: false, // enable/disable Firebase's database logging
  profileParamsToPopulate: ["responses:responses"]
};

const sagaMiddleware = createSagaMiddleware();
export const StoreInstance = createStore(
  rootReducer,
  compose(
    reactReduxFirebase(firebaseConfig, reactReduxFirebaseConfig),
    applyMiddleware(sagaMiddleware),
    persistState()
  )
);

sagaMiddleware.run(sagas);

if (StoreInstance.getState().auth && StoreInstance.getState().auth.token) {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${StoreInstance.getState().auth.token.access_token}`;
  axios.defaults.headers.common["Accept"] = `application/json`;
}

ReactDOM.render(
  <Provider store={StoreInstance}>
    <Routes history={browserHistory} />
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js